import LabServiceModel from "@/models/LabServiceModel";
import StaffModel from "./StaffModel";

export default class UserModel extends LabServiceModel {
  modelName() {
    return 'user';
  }
  defaults() {
    return {
      id: null,
      name: null,
      email: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      staff: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }
  validation() {
    return {}
  }
  getStaff() {
    return this.getRelatedModel(StaffModel, 'staff');
  }
}
